$(document).on('click', '.js-anchor', function(event) {
  event.preventDefault();

  const $element = $($(this).attr('href'));
  const scrollOffset = 24;
  
  if (!$element.length) {
    return;
  }

  $('html, body').animate({ scrollTop: $element.offset().top + scrollOffset }, 1000);
});
